<template>
	<div>
		<h1>Password reset</h1>
		<div class="row">
			<div class="col-md-6 offset-md-3">
				<div class="panel panel-login">
					<div class="panel-body">
						<div class="row">
							<div class="col-lg-12">
								<ValidationObserver ref="form">
									<form id="login-form" role="form" name="passResetForm">
										<validation-provider rules="required|min:8" v-slot="{errors,classes }">
											<div class="form-group">
												<label for="newPass">Please select new password</label>
												<input type="password" name="newPass" id="newPass" tabindex="1" class="form-control"
												       placeholder="new password" value="" v-model="passResetFormData.newPass" required
												       minlength="6" :class="classes">
												<div class="invalid-feedback">{{ errors[0] }}</div>
											</div>
										</validation-provider>
										<div class="form-group">
											<div class="row">
												<div class="col-sm-6 offset-sm-3">
													<input type="button" name="passResetsubmit" id="passResetsubmit" tabindex="4"
													       class="btn btn-primary" value="Reset password"
													       @click="passResetsubmit()">
												</div>
											</div>
										</div>
									</form>
								</ValidationObserver>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import ApiService from "../../libs/ApiService";

	export default {
		name: "PasswordReset",
		data() {
			return {
				passResetFormData: {
					newPass: null
				}
			}
		},
		methods: {
			async passResetsubmit() {
				//trigger validation
				if (!await this.$refs.form.validate()) {
					return;
				}
				let token = this.$route.params.token;
				await ApiService.post('/auth/passResetSetNew/' + token, this.passResetFormData);
				this.$router.push('/front/login');
			}
		}
	}
</script>

<style scoped>

</style>